module.exports = __webpack_public_path__ + "static/assets/66bc71cc7b7e48ee3449bc35de71545f.png";